import React from "react";
import { motion } from "framer-motion";
import { TrendingUp, Globe, Target, Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";

export default function StatsBar() {
  const stats = [
    {
      icon: TrendingUp,
      value: "€343B → €392B",
      label: "EU Defence Spend Growth",
      tooltip: "EU defence outlays 2024-2025, reflecting accelerated rearmament across member states",
      source: "NATO & EU Commission Reports 2024"
    },
    {
      icon: Target,
      value: "€62.4B + €24B",
      label: "Germany 2025 Defence",
      tooltip: "Annual budget plus special fund allocation, marking historic shift in German defence policy",
      source: "German Federal Budget 2025"
    },
    {
      icon: Globe,
      value: "~US$2.8–4.0T",
      label: "Projected 2035 NATO Spend",
      tooltip: "Based on ≥3.5% GDP target pathway under expanded 5% defence & security pledge",
      source: "NATO Summit Projections"
    },
    {
      icon: TrendingUp,
      value: "~5% GDP",
      label: "Taiwan Defence Target 2030",
      tooltip: "Rising from 3.32% in 2026, reflecting Indo-Pacific security dynamics",
      source: "Taiwan Ministry of Defense"
    }
  ];

  return (
    <div className="bg-[#0F2437] border-y border-[#24A19C]/20 py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="relative group"
            >
              <div className="flex items-start gap-4">
                <div className="bg-[#24A19C]/10 p-3 rounded-lg">
                  <stat.icon className="w-6 h-6 text-[#24A19C]" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-2">
                    <div className="text-2xl font-bold text-[#E0B422]">{stat.value}</div>
                    <TooltipProvider>
                      <Tooltip>
                        <TooltipTrigger>
                          <Info className="w-4 h-4 text-[#6B7C93] hover:text-[#24A19C] transition-colors" />
                        </TooltipTrigger>
                        <TooltipContent className="max-w-xs bg-[#0F2437] border-[#24A19C]/30">
                          <p className="text-sm mb-2">{stat.tooltip}</p>
                          <p className="text-xs text-[#6B7C93]">Source: {stat.source}</p>
                        </TooltipContent>
                      </Tooltip>
                    </TooltipProvider>
                  </div>
                  <div className="text-sm text-[#6B7C93]">{stat.label}</div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}